import React from "react";
import { Card } from "../modules/Users";

export function UserCardPage(props) {
  return <Card {...props} />;
}
